import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmInput } from '@spartan-ng/helm/input';
import { HlmLabel } from '@spartan-ng/helm/label';

import { HlmFieldImports } from '@spartan-ng/helm/field';
import { DetailSciencesEtCultureFormGroup } from '../jalon-detail-form-groups.types';

@Component({
  selector: 'app-detail-sciences-culture',
  imports: [ReactiveFormsModule, HlmInput, HlmFieldImports, HlmLabel],
  templateUrl: './detail-sciences-culture.component.html',
})
export class DetailSciencesCultureComponent {
  readonly form = input.required<DetailSciencesEtCultureFormGroup>();
}
